import { render, staticRenderFns } from "./StudentContactForm.vue?vue&type=template&id=3419259c&scoped=true"
import script from "./StudentContactForm.vue?vue&type=script&lang=js"
export * from "./StudentContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3419259c",
  null
  
)

export default component.exports